import * as React from 'react';
import {useAllUsersQuery} from "../../types.d";
import Select from 'react-select';

export const UsersSelectList = (props: { roles?: string[], onSelect: (id: number) => any }) => {
    const users = useAllUsersQuery({
        variables: {
            roles: props.roles
        }
    });

    if (!users.data) {
        return null;
    }

    return <Select
        className="basic-single"
        classNamePrefix="select"
        isSearchable={true}
        name="color"
        onChange={value => props.onSelect(value.value)}
        options={users.data.allUsers.map(item => ({
            label: `${item.email} (${item.firstName} ${item.lastName})`,
            value: item.id
        }))}
    />
};
